export enum PatientDetailsPagesEnum {
  Appointment = 'appointment',
  BasicEligibility = 'basicEligibility',
  PatientPlan = 'patientPlan',
  Coverages = 'coverages',
  EligibilityLogs = 'eligibilityLogs',
  Complete = 'complete'
}
export type PatientDetailsPageAccess = Record<PatientDetailsPagesEnum, boolean>;

export enum PayerCredentialPagesEnum {
  ListPayerCredential = 'list-payer-credential',
  UpdatePayerCredential = 'update-payer-credential',
  AddPayerCredential = 'add-payer-credential',
  DeletePayerCredential = 'delete-payer-credential',
  RequestEmail = 'mfa-management'
}
export type PayerCredentialPageAccess = Record<PayerCredentialPagesEnum, boolean>;

export enum BenefitChecksPagesEnum {
  YearlyBenefitCheck = 'yearly-benefit-check'
}
export type BenefitChecksPageAccess = Record<BenefitChecksPagesEnum, boolean>;

export enum GroupEmbedPagesEnum {
  DailyHuddle = 'dailyHuddle',
  Resync = 'resync',
  NewEligibilityCheck = 'newEligibilityCheck',
  StatusChange = 'statusChange',
  BenefitEdit = 'benefitEdit',
  AppointmentNote = 'appointmentNote',
  DownloadAppointment = 'downloadAppointment',
  Patients = 'patients',
  InformationIcon = 'informationIcon'
}

export type GroupEmbedPageAccess = Record<GroupEmbedPagesEnum, boolean>;

export enum ProviderManagementPagesEnum {
  ProviderManagement = 'provider-management',
  AddUpdateProvider = 'add-update-provider'
}

export type ProviderManagementPageAccess = Record<ProviderManagementPagesEnum, boolean>;
